import { InjectionToken } from '@angular/core';
import { Environment } from '@libs/types';

export const APP_CONFIG = new InjectionToken<Environment>(
  'Application environment config',
);
